import Vue from 'vue';
import axios from 'axios';
import { DxTextBox, DxDateBox, DxNumberBox, DxTextArea, DxSelectBox } from 'devextreme-vue';

const CustomFieldType = {
  kString:  0,
  kInt:     1,
  kDouble:  2,
  kDate:    3,
  kLookup:  4,
  kLibrary: 5
};

export default {
  name: 'CustomFieldsApp',
  props: ['dataObj'],
  components: {
    DxTextBox, DxDateBox, DxNumberBox, DxTextArea, DxSelectBox
  },
  data: function () {
    return {
      groupTabs: [],
      lookups: [],
      allLookups: [],
      libraries: [],
      allLibraries: [],
      dialogRecords: [],
      componentKey: 0,
      spanKey: 0,
      compKey2: 0,
      dialogRecordId: 0,
      bShowDialog: false,
      selectedOption: ''
    }
  },
  computed: {
    dropDownExist: function () {
      return !this.dataObj.every(f => f.type != 4);
    }
  },
  watch: {

  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.groupTabs = [];

      if ((this.dataObj) && (this.dataObj.length > 0)) {
        this.groupTabs = this.dataObj.map(a => a.groupName).filter(this.distinctValues);
        this.dataObj.forEach(item => {
          if ((item.type === CustomFieldType.kLookup) && (item.dataId === 0))
            item.dataId = null;
        });
      }

      if (this.dataObj.length > 0)
        this.dataObj.forEach(item => {
          item.name = item.unitLabel && item.unitLabel.length > 0 ? item.name + ' (' + item.unitLabel + ')' : item.name
          if (item.isMandatory === true && item.name.indexOf('*') === -1)
            item.name = item.name + ' *';
        });

      var lookupCalls = [];
      var libraryCalls = [];
      if (this.dataObj.length > 0) {
        var fLookups = this.dataObj.filter(t => t.type == CustomFieldType.kLookup);

        fLookups.forEach((lookup) => {
          lookup.bShowIcon = false;
          this.getCustomFieldLookupValues(lookup);
        });

        var fLibraries = this.dataObj.filter(t => t.type == CustomFieldType.kLibrary);

        fLibraries.forEach((library) => {
          if (libraryCalls.includes(library.typeId) === false) {
            library.bShowIcon = false;
            this.getCustomFieldLibraryValues(library);
            libraryCalls.push(library.typeId);
          }
        });
      }

    },
    showDialog(field) {
      this.dialogRecords = this.lookups[field.customFieldId];
      this.dialogRecordId = field.customFieldId;
      this.bShowDialog = true;
    },
    selectType4Value(record) {
      var customFieldsByType = this.dataObj.filter(item => item.typeId === record.typeId && item.customFieldId == this.dialogRecordId);
      if (customFieldsByType && customFieldsByType.length > 0)
        customFieldsByType.forEach(item => item.dataId = record);
      this.bShowDialog = false;
      this.dialogRecordId = 0;
    },
    valueChanged(value) {
      //console.log(value);
      this.$root.$emit('custom_field_changed');
    },
    selectBoxChanged(value) {
      var selectedItem = value.value;
      if (!value.value)
        return;

      this.$root.$emit('custom_field_changed');

      //var orderId = value.element.id;
      //orderId = parseInt(orderId);

      //var cascadingChildren = this.dataObj.filter(item => item.parentTypeId === selectedItem.typeId && item.orderId === orderId + 1);
      //if ((cascadingChildren) && (cascadingChildren.length > 0)) {
      //  cascadingChildren.forEach(item => {
      //    this.lookups[item.typeId] = this.allLookups[item.typeId].filter(subItem => subItem.parentItemId === selectedItem.itemId);
      //  });
      //}
      this.componentKey++;
      //this.$forceUpdate();
    },
    onChangeSelect(currentField) {

      var customFieldId = currentField.customFieldId;

      if (currentField.dataId && currentField.dataId.name !== "")
        this.selectedOption = currentField.dataId.name;

      if (currentField.dataId === null && currentField.type === 4)
        this.spanKey++;

      var childField = this.dataObj.filter(item => item.parentCustomFieldId === customFieldId);
      childField = childField.length > 0 ? childField[0] : null;

      if (childField !== null) {
        if (!currentField.dataId || currentField.dataId === 0 || currentField.dataId.itemId === 0)
          childField.dataId = null;
        if (currentField.dataId !== null)
          this.lookups[childField.customFieldId] = this.allLookups[childField.customFieldId] ? this.allLookups[childField.customFieldId].filter(subItem => subItem.parentItemId === currentField.dataId.itemId) : this.allLookups[childField.customFieldId];
        else
          this.lookups[childField.customFieldId] = [];

        var childLookups = this.lookups[childField.customFieldId];
        if (childLookups && childLookups.filter(p => p.itemId == childField.dataId.itemId).length === 0)
          childField.dataId = null;
        this.componentKey++;
      }
      this.compKey2++;
      this.$root.$emit('custom_field_changed');
    },
    getGroupFields(groupName) {
      var setFields = this.dataObj.filter(item => item.groupName == groupName);
      if (setFields && setFields.length > 0)
        setFields.forEach(item => {
          if (item.type === 4 && (item.dataId === undefined || item.dataId === null)) {
            item.dataId = {
              itemId: 0,
              name: '',
              parentItemId: 0,
              parentTypeId: 0,
              typeId: 0,
            };
          }
        });
      return setFields;
    },
    distinctValues(value, index, self) {
      return self.indexOf(value) === index;
    },
    getCustomFieldLookupValues(customField) {
      axios.get('/CustomField/GetLookupValues?lookupId=' + customField.typeId)
        .then(response => {
          if (response.status == 200) {
            if (customField.parentCustomFieldId === undefined || customField.parentCustomFieldId === null)
              this.lookups[customField.customFieldId] = response.data;
            else
              this.lookups[customField.customFieldId] = [];

            this.allLookups[customField.customFieldId] = response.data;

            if (typeof customField.dataId != 'object') {
              let option = response.data.filter(d => d.itemId == customField.dataId);

              if (option && option.length > 0)
                this.dataObj.filter(d => d.customFieldId == customField.customFieldId)[0].dataId = option[0];
            }

            customField.bShowIcon = response.data.filter(p => p.name.length >= 50).length > 0;
            this.$forceUpdate();
          }
        })
        .catch(e => {
          //this.$router.push('/login');
          return false;
        })
    },
    getCustomFieldLibraryValues(customField) {
      axios.get('/CustomField/GetLibraryValues?libraryId=' + customField.typeId)
        .then(response => {
          if (response.status == 200) {
            this.libraries[customField.customFieldId] = response.data;
            this.allLibraries[customField.customFieldId] = response.data;
            customField.bShowIcon = response.data.filter(p => p.name.length >= 50).length > 0;
          }
        })
        .catch(e => {
          this.$router.push('/login');
          return false;
        })
    },
  },
}

